import { ValueFormatterParams } from "ag-grid-community";

export function nvdHCFormatter({ value, data }: ValueFormatterParams): string {
  if (!data) {
    return "";
  }

  const hc = parseInt(value, 10);
  if (Number.isNaN(hc) === false) {
    return String(hc);
  } else {
    return "-";
  }
}
